import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';

interface AdditionalFee {
  id: number;
  fee_type: string;
  fee_amount: number;
  fee_payer_id: number | null;
  created_at: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
`;

const TotalRow = styled(Row)`
  border-bottom: none;
`;

const Label = styled.span<{ isTotal?: boolean; isLarge?: boolean }>`
  font-size: ${({ isTotal, isLarge }) => (isTotal ? '16px' : isLarge ? '14px' : '12px')};
  font-weight: 500;
  color: #000;
`;

const Value = styled.span<{ isTotal?: boolean; isLarge?: boolean }>`
  font-size: ${({ isTotal, isLarge }) => (isTotal ? '16px' : isLarge ? '14px' : '12px')};
  font-weight: 500;
  color: #000;
`;

const formatAmount = (amount: number) =>
  `$${amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

interface PricingBlockProps {
  vehicle: Vehicle & { vehicle_price?: number; additional_fees?: AdditionalFee[] };
}

const PricingBlock = ({ vehicle }: PricingBlockProps) => {
  const vehiclePrice = vehicle.vehicle_price ?? 0;
  const buyFee = vehicle.buy_fee?.processing_fee ?? 666;
  const transportationFee = vehicle.buy_fee?.transportation_fee ?? 666;
  const additionalFees = vehicle?.additional_fees ?? [];
  const additionalFeesTotal = additionalFees.reduce((sum, f) => sum + Number(f.fee_amount), 0);
  const totalPrice = vehiclePrice + buyFee + transportationFee + additionalFeesTotal;

  return (
    <Wrapper>
      <Row>
        <Label isLarge>Vehicle Price</Label>
        <Value isLarge>{formatAmount(vehiclePrice)}</Value>
      </Row>
      <Row>
        <Label>Buy fee</Label>
        <Value>{formatAmount(buyFee)}</Value>
      </Row>
      {additionalFees.map(fee => (
        <Row key={fee.id}>
          <Label>{fee.fee_type}</Label>
          <Value>{formatAmount(fee.fee_amount)}</Value>
        </Row>
      ))}
      {transportationFee > 0 && (
        <Row>
          <Label>Transportation fee</Label>
          <Value>{formatAmount(transportationFee)}</Value>
        </Row>
      )}
      <TotalRow>
        <Label isTotal>Total Price</Label>
        <Value isTotal>{formatAmount(totalPrice)}</Value>
      </TotalRow>
    </Wrapper>
  );
};

export default PricingBlock;
